// NPM Imports
import React, { Fragment } from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
// import { AttachWorkflowBtnTnb } from "../../../../componentsTnb";
// import { FeatureGating } from "../../../../commonComponents";
import DyanamicFeildAttachWorkflow from "../DynamicFeildAttachWorkflow";

// Internal Imports
import { COMMON } from "../../../../constants";

// Destructuring
const { DOCUMENT_LABELS } = COMMON;

export default function AttachWorkflowBtn(props) {
  const { entity } = props;

  return (
    // <FeatureGating
    //   name={FEATURES_NAME.TEMPLATES_WORKFLOW_DF}
    //   altComponent={<AttachWorkflowBtnTnb {...props} />}>
    <div
      className="dynamicfieldlist-action-wrapper"
      data-test="attachworkflowbtn-dynamicfieldlist-action-wrapper">
      {entity.workflowEnabled && !props.isLocked && (
        <DyanamicFeildAttachWorkflow {...props} />
        // <div
        //   className={`dynamicfieldlist-add-workflow ${
        //     entity.wfId ? "workflow-attached" : ""
        //   }`}
        //   data-test="attachworkflowbtn-add-workflow-button"
        //   onClick={() => props.toggleWorkFlowScreen({ flag: true, entity })}
        //   onKeyPress={() => null}
        //   role="button"
        //   tabIndex="0">
        //   {entity.wfId ? (
        //     <FontAwesomeIcon
        //       icon={["far", "network-wired"]}
        //       className="dynamicfieldlist-icon-network"
        //     />
        //   ) : (
        //     <FontAwesomeIcon
        //       icon={["far", "network-wired"]}
        //       className="dynamicfieldlist-icon-plus"
        //     />
        //   )}
        //   {entity.wfId ? "Workflow Attached" : "Attach Workflow"}
        // </div>
      )}

      {entity.type === "DYNAMICFIELD" && !props.isLocked && (
        <Fragment>
          <Tooltip
            placement="top"
            overlay="Edit form field"
            align={{
              offset: [0, 4],
            }}
            data-test="attachworkflowbtn-dynamicfieldlist-info-ico-tooltip">
            <div
              className="dynamicfieldlist-info-ico"
              data-test="attachworkflowbtn-dynamicfieldlist-info-ico">
              <FontAwesomeIcon
                icon={["far", "edit"]}
                onClick={() => props.goForUpdateFormField(props)}
                onKeyPress={() => null}
                role="button"
                tabIndex="0"
              />
            </div>
          </Tooltip>
          <Tooltip
            placement="top"
            overlay={`Remove ${DOCUMENT_LABELS["dynamic-label"]} Field`}
            align={{
              offset: [0, 4],
            }}
            data-test="attachworkflowbtn-dynamicfieldlist-delete-ico-tooltip">
            <div
              className="dynamicfieldlist-delete-ico"
              data-test="attachworkflowbtn-dynamicfieldlist-delete-ico"
              onClick={event => props.removeDynamicFiled(event, entity)}
              onKeyPress={() => null}
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "trash-alt"]} />
            </div>
          </Tooltip>
        </Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/AttachWorkflowBtn/AttachWorkflowBtn.js